import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';

const Header = ({ headers, colSize, textAlign }) => {
  const {
    Table: { Header: HeaderComponent, Row }
  } = UX2.Element;
  return (
    <Row>
      { headers.map((header, index) => (
        <HeaderComponent
          data-id='col-container'
          children={ header }
          style={{ textAlign: textAlign[index], flex: colSize[index] || 1 }}
          key={ `table-header-column-${header}` }
        />
      )) }
    </Row>
  );
};

Header.propTypes = {
  headers: PropTypes.array.isRequired,
  colSize: PropTypes.array,
  textAlign: PropTypes.array
};

Header.defaultProps = {
  headers: [],
  colSize: [],
  textAlign: []
};

export default Header;
